import 'rxjs/add/operator/debounceTime';
import {Component, ViewChild} from '@angular/core';
import {Content, NavController, NavParams} from 'ionic-angular';

import {CONFIG} from '../../../app/config';
import {TFieldType, TGoogleAnalytic, TStatusBar, Util} from "../../../app/util";

import {LogadoService} from '../../../providers/logado-service';
import {DomSanitizer} from "@angular/platform-browser";
import {ENUM, TAction, TProfileTeam, TSubjectCare, TSubjectFrom} from "../../../app/enum";
import {SupportService} from "../../../providers/support-service";
import {HotspotService} from "../../../providers/hotspot-service";
import {ProfilePagePage} from "../profile-page/profile-page";
import {ModalFieldPage} from "../modal-field/modal-field";
import {WebstorOpenPage} from "../webstor-open/webstor-open";
import {NegocioMenuPage} from "../negocio-menu/negocio-menu";
import {ModalActionPage} from "../modal-action/modal-action";
import {ProfileService} from "../../../providers/profile-service";
import {DragButton} from "../../../components/drag-button/drag-button";


@Component({
    selector: 'page-support-menu',
    templateUrl: 'support-menu.html',
    providers: [HotspotService, SupportService, ProfileService]
})
export class SupportMenuPage {

    ENUM: any = ENUM;
    config: any;

    TProfileTeam: any = TProfileTeam;
    TSubjectCare: any = TSubjectCare;

    logado: any;

    etapa: any;
    subjects: any;
    subcopys: any;
    selected: number;

    hotspotID: number;


    //ETAPA - 0
    filter: number;
    filtex: number;

    subjectFrom: TSubjectFrom;
    messageNova: any;

    @ViewChild(Content) content: Content;
    @ViewChild(DragButton) dragButton: DragButton;

    constructor(public navCtrl: NavController, public navParams: NavParams,
                public util: Util, public sanitizer: DomSanitizer,
                public logadoService: LogadoService,
                public profileService: ProfileService,
                public supportService: SupportService,
                public hotspotService: HotspotService) {

        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();

        this.etapa = this.navParams.get('etapa');
        this.subjects = this.navParams.get('subjects');
        this.selected = this.navParams.get('selected');

        this.hotspotID = this.navParams.get('hotspotID');

        this.filter = 0;
        this.filtex = 0;

        this.subjectFrom = TSubjectFrom.sfSos;

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Webstor Support', '/webstor-support');

        //397.752.798-36 - BRUNA LOPES
        let profile = this.navParams.get('profile');

        if (this.etapa == -1) this.subjectNovo(profile);
        if (this.etapa == 0) this.subjectLoad();
        if (this.etapa == 1) this.messageLoad();

    }

    ionViewDidLoad() {


    }

    ionViewDidEnter() {

        this.util.statusBarColor(TStatusBar.sbStyleLightContent);
        if (this.filter == 0 && this.logado.Profile.ProfileWork) this.dragButton.setChecked(true);

    }

    getTitle() {

        let subject = (this.subjects || [])[this.selected];

        if (this.etapa == -1) return (subject.Hotspot ? subject.Hotspot.BrandedShow : 'Atendimento');
        if (this.etapa == 0) return TSubjectFrom[this.subjectFrom].slice(2, 99);
        if (this.etapa == 1) return '#' + subject.SubjectID;
        if (this.etapa == 2) return '#' + subject.SubjectID;

    }

    expanded(message) {

        message.expanded = !message.expanded;

    }

    convert(funct: any) {

        eval(funct);

    }

    profilePage(profile) {

        let object = {profileID: profile.ProfileID};
        this.navCtrl.push(ProfilePagePage, object);

    }

    profileWork() {

        this.logado.Profile.ProfileWork = !this.logado.Profile.ProfileWork;

        let onErro = (erro) => {
            this.logado.Profile.ProfileWork = !this.logado.Profile.ProfileWork;
            this.dragButton.setChecked(this.logado.Profile.ProfileWork);
            this.util.alertResult(erro);
        };

        let work = !this.logado.Profile.ProfileWork;
        
        let loading = this.util.loadingDots();
        loading.present();

        this.profileService.profile(TAction.acWork, this.logado.Profile.ProfileID, null, '&ProfileShip=' + work)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {},
                erro => onErro(erro)
            );

    }

    subjectNovo(profile) {

        let subjectNovo = {Profile: null, Hotspot: null, Messages: []};
        subjectNovo.Profile = profile;
        this.subjects = [subjectNovo];

        this.messageNovo();

    }

    messageNovo() {

        this.messageNova = {};
        this.messageNova.MessageID = 0;
        this.messageNova.MessageCria = this.util.dateToStr();
        this.messageNova.MessageCode = '';
        this.messageNova.MessageBody = '';
        this.messageNova.MessageHtml = this.messageNova.MessageBody;
        this.messageNova.Arquivos    = [];
        this.messageNova.Profile     = this.util.deepCopy(this.logado.Profile);
        this.messageNova.Mailing     = null;
        this.messageNova.expanded    = true;

    }

    subjectPop3() {

        let onPop3 = (from) => {

            this.subjectFrom = from;
            this.subjectLoad();

        };

        let manager = (this.logado.Profile.ProfileTeam >= TProfileTeam.mkManager);
        let ellzito = (this.logado.Profile.ProfileZito);

        /** OPEN **/
        let buttons: Array<any> = [];
                     buttons.push({text: 'BUG', handler: () => onPop3(TSubjectFrom.sfSos)});
        if (manager) buttons.push({text: 'ADM', handler: () => onPop3(TSubjectFrom.sfAdm)});
        if (ellzito) buttons.push({text: 'CEO', handler: () => onPop3(TSubjectFrom.sfCeo)});
        this.util.sheetOpen(buttons, 'POP3');

    }

    subjectLoad() {

        let onLoad = (data) => {
            this.subcopys = data.Subjects;
            this.subjectShow(this.filter);
        };

        let params = '&SubjectFrom=' + this.subjectFrom +
                     '&SubjectView=' + this.filter;

        let loading = this.util.loadingDots();
        loading.present();

        this.supportService.subject(TAction.acLoad, 0, this.hotspotID, this.logado.Profile.ProfileID, 0, 0, null, params)
            .finally(() => loading.dismiss())
            .subscribe(
                data => onLoad(data),
                erro => this.util.alertResult(erro, () => this.dismiss())
            );

    }

    subjectSave(that?) {

        let onSave = (data) => {
            if (that) that.dismiss();
            this.dismiss();
        };

        let json = this.subjects[this.selected];

        let loading = this.util.loadingDots();
        loading.present();

        this.supportService.subject(TAction.acSave, json.SubjectID, 0, 0, 0, 0, json)
            .finally(() => loading.dismiss())
            .subscribe(
                data => onSave(data),
                erro => this.util.alertResult(erro, () => this.dismiss())
            );

    }

    mailingSave(that, mailing) {

        let onSave = (data) => {
            mailing.MailingID = data.Return;
            if (that) that.dismiss();
            this.dismiss();
        };

        let loading = this.util.loadingDots();
        loading.present();

        this.supportService.mailing(TAction.acSave, mailing.MailingID, this.subjects[this.selected].SubjectID, mailing)
            .finally(() => loading.dismiss())
            .subscribe(
                data => onSave(data),
                erro => this.util.alertResult(erro, () => this.dismiss())
            );

    }

    settingMenu() {

        let object = {etapa: 2, profile: null, hotspotID: this.hotspotID, subjects: this.subjects, selected: this.selected};
        this.navCtrl.push(SupportMenuPage, object);

        this.supportService.mailing(TAction.acLoad, 0, this.subjects[this.selected].SubjectID)
            .subscribe(
                data => this.subjects[this.selected].Mailings = data.Mailings,
                erro => this.util.alertResult(erro, () => this.dismiss())
            );

    }

    subjectMove() {

        let onOkey = (okey, that, data) => {

            let onDone = (data) => {
                this.subjects.splice(this.selected, 1);
                this.navCtrl.getPrevious().dismiss();
                this.dismiss();
                setTimeout(() => that.dismiss(), 500);
            };

            let params = '&SubjectIX=' + okey.inputf.text.slice(2, 99);

            let loading = this.util.loadingDots();
            loading.present();

            this.supportService.subject(TAction.acMove, this.subjects[this.selected].SubjectID, 0, 0, 0, 0, null, params)
                .finally(() => loading.dismiss())
                .subscribe(
                    data => onDone(data),
                    erro => this.util.alertResult(erro, () => this.dismiss())
                );

        };

        let objectData = {modalfull: false, modalinfo: this.config.modalinfo(this.util, 'fundir', onOkey, null, false, '')};
        this.util.modalopen(ModalActionPage, 'wide', true, objectData).subscribe();

    }

    subjectPush(index: number) {

        let object = {etapa: 1, profile: null, hotspotID: this.hotspotID, subjects: this.subjects, selected: index};
        this.navCtrl.push(SupportMenuPage, object);

    }

    subjectTint(subject, hexa?) {

        let tint = '';
        if (subject.SubjectCare == TSubjectCare.scEmergency) tint = 'CorFood';
        if (subject.SubjectCare == TSubjectCare.scAtenttion) tint = 'CorWeek';
        if (subject.SubjectCare == TSubjectCare.scNormality) tint = '';

        if (tint && hexa) return this.config.colors[tint];
        return tint;

    }

    subjectShow(filter) {

        if (filter == 1) this.subjects = this.subcopys.filter(SU => (!SU.SubjectLock));
        if (filter == 2) this.subjects = this.subcopys.filter(SU => (!SU.SubjectRead));
        if (filter == 3) this.subjects = this.subcopys.filter(SU => (SU.SubjectCare > TSubjectCare.scNormality));
        if (filter == 4) this.subjects = this.subcopys.filter(SU => (SU.SubjectLock));
        this.filter = filter;

    }

    mailingLixo(event, mailing) {

        event.stopPropagation();

        let onLixo = () => {

            let loading = this.util.loadingDots();
            loading.present();

            this.supportService.mailing(TAction.acLixo, mailing.MailingID, this.subjects[this.selected].SubjectID)
                .finally(() => loading.dismiss())
                .subscribe(
                    data => {

                        let index = this.subjects[this.selected].Mailings.indexOf(mailing);
                        this.subjects[this.selected].Mailings.splice(index, 1);

                    },
                    erro => {

                        this.util.alertResult(erro);

                    });

        };

        let alerta = '<b>Deseja excluir?</b><br/>' + 'Este processo não tem volta.<br/><br/>';
        this.util.alertQuestion('ATENÇÃO', alerta, 'Continuar', () => onLixo(), false, true);

    }

    subjectLixo() {

        let onLixo = () => {

            let onDone = () => {

                if (this.etapa == 2) {
                    this.navCtrl.getPrevious().dismiss();
                    this.dismiss();
                }

                this.subjects.splice(this.selected, 1);

            };

            let loading = this.util.loadingDots();
            loading.present();

            this.supportService.subject(TAction.acLixo, this.subjects[this.selected].SubjectID)
                .finally(() => loading.dismiss())
                .subscribe(
                    data => onDone(),
                    erro => this.util.alertResult(erro, () => this.dismiss())
                );

        };

        let alerta = '<b>Deseja excluir?</b><br/>' + 'Este processo não tem volta.<br/><br/>';
        this.util.alertQuestion('ATENÇÃO', alerta, 'Continuar', () => onLixo(), false, true);

    }

    subjectLock() {

        let lock = this.subjects[this.selected].SubjectLock;
        this.subjects[this.selected].SubjectLock = (lock ? null : this.util.dateToStr());
        this.subjectSave();

    }

    subjectCare() {

        let onSave = (care) => {
            this.subjects[this.selected].SubjectCare = care;
            this.subjectSave();
        };

        /** OPEN **/
        let arrayEnum = this.util.enumArray(TSubjectCare);
        let buttons: Array<any> = [];
        arrayEnum.forEach(care => buttons.push({text: care.slice(2, 99), handler: () => onSave(TSubjectCare[care])}));
        this.util.sheetOpen(buttons, 'PRIORITY');

    }

    messageLoad() {

        let subject = this.subjects[this.selected];

        let onLoad = (data) => {

            //Ultima mensagem deixa ela expandida
            subject.Messages = data.Messages;
            subject.Messages.map((message, index) => {

                let el = document.createElement('div');
                el.innerHTML = message.MessageBody;

                let metas = el.getElementsByClassName('moz-cite-prefix');
                if (metas.length) metas[0].remove();

                let quote = el.getElementsByClassName('gmail_quote');
                if (quote.length) quote[0].remove();

                let signa = el.getElementsByClassName('moz-signature');
                if (signa.length) signa[0].remove();

                message.MessageHtml = this.sanitizer.bypassSecurityTrustHtml(el.innerHTML);
                message.expanded = (subject.Messages.length == index + 1);

            });
            subject.SubjectRead = true;

            if (subject.Messages.length > 1) {
                setTimeout(() => {
                    this.content.scrollTo(0, this.content.getScrollElement().scrollHeight, 0)
                }, 0);
            }

            setTimeout(() => {
                let signe = document.getElementById('Signature');
                if (signe) {
                    console.log('AKI', signe);
                    signe.remove();
                }

                let old = document.getElementById('appendonsend');
                if (old) {
                    let one = old.nextElementSibling;
                    if (one) one.remove();

                    let two = old.nextElementSibling;
                    if (two) two.remove();

                    let tre = old.nextElementSibling;
                    if (tre) tre.remove();

                }


                //Prepare
                if (!this.subjects[this.selected].SubjectLock) this.messageNovo();


            }, 2000);

        };

        let loading = this.util.loadingDots();
        loading.present();

        this.supportService.message(TAction.acLoad, subject.SubjectID)
            .finally(() => loading.dismiss())
            .subscribe(
                data => onLoad(data),
                erro => this.util.alertResult(erro, () => this.dismiss())
            );

    }

    messageSend(message, that?) {

        message.MessageHtml = this.util.textReplace(message.MessageBody, '\n', '<br>');
        if (!message.MessageID) {
            this.subjects[this.selected].Messages.push(message);
            this.messageNovo();
        }
/*
        let onSave = (data, message, that) => {
            if (!message.MessageID) message.MessageID = data.Codigo;
            if (that) that.dismiss();
        };

        let onErro = (erro) => {
            let index = this.subjects[this.selected].Messages.findIndex(message);
            this.subjects[this.selected].Messages.splice(index, 1);
            this.util.alertResult(erro);
        };

        this.supportService.message(TAction.acSave, this.subjects[this.selected].SubjectID, message)
            .subscribe(
                data => onSave(data, message, that),
                erro => onErro(erro)
            );
*/

    }

    messageLeft(message): boolean {

        let subject = (this.subjects[this.selected] || {});

        let subprof = (subject.Profile || {});
        let msgprof = (message.Profile || {});
        let letprof = (subprof.ProfileID > 0 && subprof.ProfileID == msgprof.ProfileID);

        let submail = (subject.Mailing || {});
        let msgmail = (message.Mailing || {});
        let letmail = (submail.MailingID > 0 && submail.MailingID == msgmail.MailingID);

        let letuser = (msgprof.ProfileID == this.logado.Profile.ProfileID);
        return ((letprof || letmail) && !letuser);

    }

    messageEdit(message) {

        let onOkiy = (that, okiy, index, isLast) => {

            if (this.util.slideNext(that, !isLast)) return;

            message.MessageBody = okiy[0].groups[0].fields[0].value;
            message.MessageHtml = okiy[0].groups[0].fields[0].value;
            this.messageSend(message, that);

        };

        /** SLIDE 01 **/
        let fieldFast = this.config.modalField(TFieldType.ftHtml, null, null, null, message.MessageBody, null, null);
        let groupFast = this.config.modalGroup(null, [fieldFast]);
        let slideFast = this.config.modalSlide('Mensagem', null, null, null, 'CorDash', [groupFast]);

        let slides = [slideFast];

        this.util.modalopen(ModalFieldPage, 'quad', false, {slides: slides, onOkiy: onOkiy}).subscribe();

    }

    arquivoCria() {

        let filebyte = (200 * 1024);
        let acceptis = 'text/plain,application/pdf,image/png,image/jpg';
        let options = {acceptTypes: acceptis, sizebyte: filebyte, selectLimit: 0, minmax: 'FIX', width: 0, height: 0, quality: 100};
        this.util.fileSelect(options).subscribe(
            base => {

                let arquivo = {ArquivoID: 0, ArquivoNome: base[0].info.name, ArquivoSize: base[0].info.size, ArquivoBase64: base[0].base64.split(',')[1]};
                this.messageNova.Arquivos.push(arquivo);

            },

            erro => this.util.alertResult(erro)
        );

    }

    arquivoTira(index) {

        this.messageNova.Arquivos.splice(index, 1);

    }

    arquivoOpen(message, fileindex) {

        let onSave = () => {

        };

        let onLixo = () => {
            let loading = this.util.loadingDots();
            loading.present();

            this.supportService.arquivo(TAction.acLixo, message.Arquivos[fileindex].ArquivoID)
                .finally(() => loading.dismiss())
                .subscribe(
                    data => message.Arquivos.splice(fileindex, 1),
                    erro => this.util.alertResult(erro)
                );
        };

        /** OPEN **/
        let buttons: Array<any> = [];
        buttons.push({text: 'Salvar', handler: () => onSave()});
        buttons.push({text: 'Excluir', handler: () => onLixo()});
        this.util.sheetOpen(buttons, message.Arquivos[fileindex].ArquivoNome);

    }

    mailingEdit(mailing) {

        let mailingNovo = (mailing == null);
        if (mailingNovo) mailing = {MailingID: 0, MailingFirm: '', MailingUser: '', MailingMail: ''};


        let onOkiy = (that, okiy, index, isLast) => {

            if (this.util.slideNext(that, !isLast)) return;

            mailing.MailingFirm = okiy[0].groups[0].fields[0].value;
            mailing.MailingUser = okiy[0].groups[1].fields[0].value;
            mailing.MailingMail = okiy[0].groups[2].fields[0].value;
            this.mailingSave(that, mailing);

        };


        /** SLIDE 01 **/
        let fieldNome = this.config.modalField(TFieldType.ftLine, 'Firm', null, null, mailing.MailingFirm, null, null);
        let groupNome = this.config.modalGroup(null, [fieldNome]);

        let fieldNick = this.config.modalField(TFieldType.ftLine, 'User', null, null, mailing.MailingUser, null, null);
        let groupNick = this.config.modalGroup(null, [fieldNick]);

        let fieldMail = this.config.modalField(TFieldType.ftMail, 'Mail', null, null, mailing.MailingMail, null, null);
        let groupMail = this.config.modalGroup(null, [fieldMail]);


        /** SLIDE SET **/
        let slides = [
            this.config.modalSlide('Info', null, null, null, 'CorRoxa', [groupNome, groupNick, groupMail]),
        ];

        this.util.modalopen(ModalFieldPage, 'wide', false, {slides: slides, onOkiy: onOkiy}).subscribe();

    }

    hotspotFind() {

        let onDone = (data) => {

            if (!data) return;

            //Cria
            if (this.etapa == -1) {
                this.subjects[this.selected].Hotspot = data;
                this.assuntoMenu();
            }

            //Edit
            if (this.etapa == 2) {
                this.subjects[this.selected].Hotspot = data;
                this.subjectSave();
            }

        };

        let object = {etapa: 1, rootile: this.logado, partnerID: 0};
        this.util.modalopen(NegocioMenuPage, 'wide', false, object).subscribe(data => onDone(data));

    }

    assuntoMenu() {

        let onDone = (data) => {

            //Cria
            if (this.etapa == -1) {
                this.subjects[this.selected].Assunto = data[0];
            }

            //Edit
            if (this.etapa == 2) {
                this.subjects[this.selected].Assunto = data[0];
                this.subjectSave();
            }

        };

        let object = {homeb: false, etapa: 0, title: null, keyname: 'Assunto', toggler: 'hide'};
        this.util.modalopen(WebstorOpenPage, 'alto', false, object).subscribe(data => onDone(data));

    }

    dismiss() {

        //Qdo volta limpa para proxima nao aparecer nada.
        if (this.etapa == 1) this.subjects[this.selected].Messages = null;

        //Show Support Button Fab
        if (this.etapa <= 0) (window as any).handappMainInstance.supportShow = /*true*/ (this.logado && this.logado.Profile.ProfileZito);

        if (this.etapa <= 0) this.navCtrl.pop({animation: 'md-transition'});
        if (this.etapa >  0) this.navCtrl.pop();

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/support-menu/support-menu.ts